export default __webpack_public_path__ + "static/media/placeholder_dummy2016-fotograf03-de.e20e2471.png";